// React and Redux
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// PropTypes
import PropTypes from 'prop-types';
// Our custom code - Config, constants, shared components and functions
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { nextPage } from '../../functions/nextPage';
import * as defaultState from '../../constants/DefaultState';
// This component
import whatToExpect from '../../../shared/imgs/what-to-expect.jpg';
import './WhatToExpectPage.css';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';

export class WhatToExpectPage extends Component {

  // parses the URL for physician first/last name and suffix
  // if at least 1 exists, formats the value and sets it as a provider
  setAppointmentProviderFromURL() {
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    const physicianFirstName = params.get('physicianFirstName');
    const physicianLastName = params.get('physicianLastName');
    const physicianSuffix = params.get('physicianSuffix');
    const physicianFullName = `${physicianFirstName ? physicianFirstName : ''}${physicianLastName ? ` ${physicianLastName}` : ''}${physicianSuffix ? `, ${physicianSuffix}` : ''}`
      .trim().substring(0, 140);
    if (physicianFullName) {
      this.props.webAppointmentSetAppointmentProvider(physicianFullName);
    }
  }

  componentDidMount() {
    if (!this.props.appointment.provider) {
      this.setAppointmentProviderFromURL();
    }

    window.onpopstate = null;
  }

  render() {
    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          {
            type: 'button',
            id: "back",
            className: "btn--secondary",
            value: 'Go Back',
            onClick: () => {
              this.props.history.goBack();
            }
          },
          {
            type: 'button',
            id: "next",
            className: "btn--primary",
            value: 'Get Started',
            onClick: () => {
              this.props.webAppointmentAcknowledgedWhatToExpect(true);
              this.props.history.push(nextPage());
            }
            //internalLink: routes.WEB_APPOINTMENT_WHO_FOR_PAGE
          }
        ]
      }
    ];


    return (
      <article className='what-to-expect-page'>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>Request an Appointment</h1>
              <hr />
            </div>
            <img className="what-to-expect__img" src={whatToExpect} alt="Illustration of laptop with arrows representing steps to completition." />
            <summary>
              <p>To fill out this form, you’ll need:</p>
              <ul>
                <li>To be 18 or older.</li>
                <li>Insurance information, if insured.</li>
                <li>Contact information of the referring provider, if applicable.</li>
              </ul>
            </summary>
            <p>This should take about 10 minutes to complete. Your appointment will be processed in 1 to 2 business days.</p>
            <p>If this is an emergency, please call 911 or go to your nearest emergency department.</p>
          </GridItem>
        </Grid>

        <InputList inputs={inputlist} isInlineList={false} />
      </article>
    );
  }
}

WhatToExpectPage.propTypes = {
  webAppointmentAcknowledgedWhatToExpect: PropTypes.func.isRequired,
  webAppointmentSetAppointmentProvider: PropTypes.func.isRequired,
  appointment: defaultState.appointmentProptype.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    appointment: state.webAppointmentForm.appointment
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentAcknowledgedWhatToExpect: (value) => dispatch(webAppointmentActions.webAppointmentAcknowledgedWhatToExpect(value)),
    webAppointmentSetAppointmentProvider: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentProvider(value))
  };
};

// connects component to redux, and passes along the router
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WhatToExpectPage));
